import React, { Fragment, memo } from 'react';
import PropTypes from 'prop-types';
import EditIcon from '@material-ui/icons/Edit';
import AddIcon from '@material-ui/icons/Add';
import Avatar from 'react-avatar';
import { IconButton } from 'material-ui';
import { DEFAULT_LEVEL, LEVEL } from '../../../shared/utils/constants';

const OrgChartNode = (props) => {
  const {
    nodeData: { nodeData },
    onClickNodeAdd,
    onClickNodeEdit,
  } = props;
  return (
    <Fragment>
      <div className="card-item">
        <div className="card-header-item justify-content-between">
          <p className="text-ellipsis pad-l12">{nodeData.shortName}</p>
          <IconButton
            id="Edit"
            className="card-icon-button"
            onClick={() => onClickNodeEdit(nodeData.id)}
          >
            <EditIcon />
          </IconButton>
        </div>
        <div className="card-body-item">
          {nodeData.iconTablet.link && (
            <Avatar
              size="50"
              round="50%"
              name={nodeData.name}
              src={nodeData.iconTablet.link}
            />
          )}
        </div>
        {nodeData.level <= LEVEL.THREE && nodeData.finalItem === false && (
          <button
            id="Add"
            type="button"
            className="card-icon-button-node"
            onClick={() =>
              onClickNodeAdd({
                id: nodeData.id,
                level: nodeData.level + DEFAULT_LEVEL,
                program: { id: nodeData.program.id },
              })
            }
          >
            <AddIcon />
          </button>
        )}
      </div>
    </Fragment>
  );
};

OrgChartNode.propTypes = {
  nodeData: PropTypes.shape(PropTypes.shape).isRequired,
  onClickNodeAdd: PropTypes.func.isRequired,
  onClickNodeEdit: PropTypes.func.isRequired,
};

export default memo(OrgChartNode);
